import { render, staticRenderFns } from "./NavDropdown.vue?vue&type=template&id=22b05102&scoped=true&"
import script from "./NavDropdown.vue?vue&type=script&lang=js&"
export * from "./NavDropdown.vue?vue&type=script&lang=js&"
import style0 from "./NavDropdown.vue?vue&type=style&index=0&id=22b05102&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b05102",
  null
  
)

export default component.exports